// Decisão pura extraída de marketdata.getBars p/ testabilidade isolada (#358) —
// marketdata.jsx não monta em node sem stubs pesados.

// #358: o AbortController ainda registrado p/ este chartId é O NOSSO?
// getBars deve liberar (delete) o controller no sucesso SÓ se for o seu — um fetch
// mais novo (troca de símbolo/periodicidade no mesmo chartId) já o substituiu via
// set(); deletar por chartId apagaria o controller do fetch novo → ele nunca aborta
// e escreve barras de símbolo stale. Espelha o identity-guard de seamReconcilers.
export function isOwnBarsController(controllers, chartId, controller) {
  return !!chartId && controllers.get(chartId) === controller;
}
